import * as React from 'react';
import { ScriptStrategy } from 'gatsby';
import Script from 'analytics/components/Script';
import useTtdSettings from '../../hooks/useTtdSettings';

export default function GlobalPixel() {
    const { hasTtdPixel, advertiserId, initId } = useTtdSettings();

    const onDomReady = React.useCallback(() => {
        if (typeof ttd_dom_ready === 'function') {
            ttd_dom_ready(() => {
                if (typeof TTDUniversalPixelApi === 'function') {
                    const universalPixelApi = new TTDUniversalPixelApi();
                    universalPixelApi.init(
                        advertiserId as string,
                        [initId as string],
                        'https://insight.adsrvr.org/track/up',
                    );
                }
            });
        }
    }, [advertiserId, initId]);

    if (hasTtdPixel) {
        return (
            <Script
                src="https://js.adsrvr.org/up_loader.1.1.0.js"
                type="text/javascript"
                strategy={ScriptStrategy.idle}
                onLoad={onDomReady}
                cookieType="marketing"
            />
        );
    }
    return null;
}
